<template>
  <div>
    <Panel title="高级配置查询">
      <template slot="buttons">
        <el-button
          title="查询"
          class="blue"
          icon="el-icon-fa-search"
          @click="pageTable.handleLoad()"
          >查询</el-button
        >
        <el-button
          title="重置"
          class="yellow"
          icon="el-icon-fa-refresh"
          @click="pageTable.handleReset()"
          >重置</el-button
        >
      </template>

      <el-form :model="pageTable.param" ref="queryForm">
        <el-row>
          <el-col :lg="4" :sm="12">
            <el-form-item prop="clientname" label="企业用户身份名称">
              <el-input v-model="pageTable.param.clientname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="4" :sm="12">
            <el-form-item prop="clientdxpid" label="企业用户身份代码(DXPID)">
              <el-input v-model="pageTable.param.clientdxpid"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Panel>
    <Panel title="高级配置列表">
      <template slot="buttons">
        <el-button
          title="添加"
          class="green"
          icon="el-icon-fa-plus"
          @click.stop="fastAddData"
          >添加</el-button
        >
        <el-button
          title="删除"
          class="red"
          icon="el-icon-fa-trash"
          @click="deletes"
          >删除</el-button
        >
      </template>
      <el-table
        highlight-current-row
        stripe
        border
        :data="pageTable.data"
        v-loading="pageTable.isLoading"
        ref="table"
        @selection-change="handleSelectionChange"
        element-loading-spinner="el-icon-loading"
        element-loading-text="数据加载中"
        height="calc(100vh - 271px)"
      >
        <el-table-column prop="$rownum" label="NO." width="50" align="center" />
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column
          prop="clientname"
          label="企业用户身份名称"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.$isEditing">{{ scope.row.clientname }}</span>
            <el-input
              v-if="scope.row.$isEditing"
              v-model="scope.row.clientname"
              maxlength="100"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="clientdxpid"
          label="企业用户身份代码(DXPID)"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.$isEditing">{{
              scope.row.clientdxpid
            }}</span>
            <el-input
              v-if="scope.row.$isEditing"
              v-model="scope.row.clientdxpid"
              maxlength="100"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="clienticno"
          label="企业用户IC卡号"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.$isEditing">{{ scope.row.clienticno }}</span>
            <el-input
              v-if="scope.row.$isEditing"
              v-model="scope.row.clienticno"
              maxlength="100"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          :formatter="formatterDateTime"
          prop="clioptime"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="发送配置" width="80" align="center">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-fa-edit"
              class="blue"
              v-if="!scope.row.$isEditing"
              @click="sendConf(scope.$index, scope.row)"
              >编辑
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="接收配置" width="80" align="center">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-fa-edit"
              class="blue"
              v-if="!scope.row.$isEditing"
              @click="receConf(scope.$index, scope.row)"
              >编辑
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.$isEditing"
              class="blue"
              icon="el-icon-edit"
              title="修改"
              @click="fastEditData(scope)"
              >修改
            </el-button>
            <el-button
              v-if="scope.row.$isEditing"
              class="blue"
              icon="el-icon-fa-save"
              title="确认"
              @click="fastConfirm(scope)"
              >保存
            </el-button>
            <el-button
              v-if="scope.row.$isEditing"
              class="yellow"
              icon="el-icon-close"
              title="取消"
              @click="fastCancel(scope)"
              >取消
            </el-button>
            <el-button
              v-if="!scope.row.$isEditing"
              class="red"
              icon="el-icon-delete"
              title="删除"
              @click="fastDelete(scope)"
              >删除
            </el-button>
            <el-button
              title="资源状态列表"
              v-if="!scope.row.$isEditing"
              class="blue"
              icon="el-icon-fa-list-ul"
              @click="showResList(scope.row.uuid)"
              >资源状态列表
            </el-button>
            <el-popover
              placement="left"
              width="1000"
              trigger="hover"
              @show="queryMondataTable(scope.row.uuid)"
              class="margin-left-1"
              :open-delay="500"
            >
              <el-table :data="monDataTable" border>
                <el-table-column type="index"></el-table-column>
                <el-table-column label="传输方向" align="center" width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sptype === '1'">{{ '发送' }}</span>
                    <span v-else>{{ '接收' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="目标身份编码"
                  prop="dxpid"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="本地协议"
                  prop="csptname"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="本地资源"
                  prop="csres"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="传输协议"
                  prop="pdptname"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="传输资源"
                  prop="pdres"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="运行状态" align="center" width="80">
                  <template slot-scope="{ row }">
                    <el-tag v-if="row.csstatus === '-1'">初始化失败</el-tag>
                    <el-tag v-else-if="row.csstatus === '0'">未初始化</el-tag>
                    <el-tag v-else-if="row.csstatus === '1'">初始化成功</el-tag>
                    <el-tag v-else-if="row.csstatus === '2'">已启动</el-tag>
                    <el-tag v-else-if="row.csstatus === '-2'">已停用</el-tag>
                    <el-tag v-else-if="row.csstatus === '-3'">已停止</el-tag>
                    <el-tag v-else>初始化</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                v-if="!scope.row.$isEditing"
                class="green"
                icon="el-icon-fa-play"
                title="全部开始"
                slot="reference"
                @click="fastStartAll(scope.$index, scope.row)"
                >全部开始
              </el-button>
            </el-popover>
            <el-popover
              placement="left"
              width="1000"
              trigger="hover"
              @show="queryMondataTable(scope.row.uuid)"
              class="margin-left-1"
              :open-delay="500"
            >
              <el-table :data="monDataTable" border>
                <el-table-column type="index"></el-table-column>
                <el-table-column label="传输方向" align="center" width="80">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sptype === '1'">{{ '发送' }}</span>
                    <span v-else>{{ '接收' }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="目标身份编码"
                  prop="dxpid"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="本地协议"
                  prop="csptname"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="本地资源"
                  prop="csres"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="传输协议"
                  prop="pdptname"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="传输资源"
                  prop="pdres"
                  align="center"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="运行状态" align="center" width="80">
                  <template slot-scope="{ row }">
                    <el-tag v-if="row.csstatus === '-1'">初始化失败</el-tag>
                    <el-tag v-else-if="row.csstatus === '0'">未初始化</el-tag>
                    <el-tag v-else-if="row.csstatus === '1'">初始化成功</el-tag>
                    <el-tag v-else-if="row.csstatus === '2'">已启动</el-tag>
                    <el-tag v-else-if="row.csstatus === '-2'">已停用</el-tag>
                    <el-tag v-else-if="row.csstatus === '-3'">已停止</el-tag>
                    <el-tag v-else>初始化</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                v-if="!scope.row.$isEditing"
                class="red"
                icon="el-icon-fa-stop"
                title="全部停止"
                slot="reference"
                @click="fastStopAll(scope.$index, scope.row)"
                >全部停止
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size.sync="pageTable.size"
        :current-page.sync="pageTable.curr"
        :total="pageTable.total"
      />

      <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        title="编辑身份"
        :visible.sync="editor.show"
        width="600px"
        :close-on-click-modal="false"
      >
        <div class="dialog-button">
          <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="doSave"
            >保存</el-button
          >
          <!-- <el-button icon="el-icon-close" type="warning" title="关闭" @click="doClose">关闭</el-button> -->
        </div>
        <IdConf
          v-if="editor.show"
          ref="idconf"
          :edi="editor"
          @son="saveId()"
        ></IdConf>
      </el-dialog>

      <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        title="发送配置列表"
        :visible.sync="senderlist.show"
        width="1000px"
        :close-on-click-modal="false"
      >
        <div class="dialog-button">
          <el-button
            title="添加"
            class="green"
            icon="el-icon-fa-plus"
            @click="addSender()"
            >添加</el-button
          >
          <el-button
            title="删除"
            class="red"
            icon="el-icon-fa-trash"
            @click="delSend()"
            >删除</el-button
          >
          <el-button
            title="全部开始"
            class="green"
            icon="el-icon-fa-play"
            @click="startAllSend"
            >全部开始</el-button
          >
          <el-button
            title="全部停止"
            class="red"
            icon="el-icon-fa-stop"
            @click="stopAllSend"
            >全部停止</el-button
          >
        </div>
        <senderList
          v-if="senderlist.show"
          ref="senderList"
          :senderUuid="senderlist.uuid"
          @editSend="editSend"
        ></senderList>
      </el-dialog>

      <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        title="接收配置列表"
        :visible.sync="receiverlist.show"
        width="1000px"
        :close-on-click-modal="false"
      >
        <div class="dialog-button">
          <el-button
            title="添加"
            class="green"
            icon="el-icon-fa-plus"
            @click="addRece()"
            >添加</el-button
          >
          <el-button
            title="删除"
            class="red"
            icon="el-icon-fa-trash"
            @click="delRece()"
            >删除</el-button
          >
          <el-button
            title="全部开始"
            class="green"
            icon="el-icon-fa-play"
            @click="startAllRece"
            >全部开始</el-button
          >
          <el-button
            title="全部停止"
            class="red"
            icon="el-icon-fa-stop"
            @click="stopAllRece"
            >全部停止</el-button
          >
        </div>
        <receiverList
          v-if="receiverlist.show"
          ref="receiverList"
          :receUuid="receiverlist.uuid"
          @editRece="editRece"
        ></receiverList>
      </el-dialog>

      <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        title="发送配置"
        :visible.sync="sender.show"
        width="600px"
        :close-on-click-modal="false"
      >
        <div class="dialog-button">
          <el-button
            title="保存发送配置"
            class="blue"
            icon="el-icon-fa-save"
            @click="saveSendConf()"
            >保存</el-button
          >
        </div>
        <IdSendConf
          v-if="sender.show"
          ref="idsendconf"
          :send="sender"
          @condSend="condSend"
        ></IdSendConf>
      </el-dialog>

      <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        title="接收配置"
        :visible.sync="receiver.show"
        width="600px"
        :close-on-click-modal="false"
      >
        <div class="dialog-button">
          <el-button
            title="保存接收配置"
            class="blue"
            icon="el-icon-fa-save"
            @click="saveReceConf()"
            >保存</el-button
          >
        </div>
        <IdReceConf
          v-if="receiver.show"
          ref="idrececonf"
          :rece="receiver"
          @condRece="condRece"
        ></IdReceConf>
      </el-dialog>

      <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        title="资源状态列表"
        :visible.sync="resList.show"
        width="1000px"
        :close-on-click-modal="false"
      >
        <ResList
          v-if="resList.show"
          ref="resListTable"
          :res="resList"
        ></ResList>
      </el-dialog>
    </Panel>
  </div>
</template>

<script>
import IdConf from './IdConf.vue';
import IdReceConf from './IdReceConf.vue';
import IdSendConf from './IdSendConf.vue';
import senderList from './senderList.vue';
import receiverList from './receiverList.vue';
import resList from './resList.vue';
import idApi from '@/api/senior/idApi.js';
import monitorApi from '@/api/senior/monitorApi';
import { PageTable } from 'cnetong-core-frontend';
import ResList from '@/module/cnetong/client/seniormgr/resList';

let defaultFormData = {
  uuid: '',
  clientname: '',
  clientdxpid: '',
  clienticno: '',
  $isEditing: true,
};
export default {
  name: 'IdConfigMgr',
  components: {
    ResList,
    IdConf,
    idApi,
    IdReceConf,
    IdSendConf,
    senderList,
    receiverList,
  },
  data() {
    return {
      pageTable: new PageTable({
        doLoad: idApi.select,
        autoLoad: true,
      }),
      cond: '',
      multipleSelection: [],
      queryForm: {
        clientname: '',
        clientdxpid: '',
      },
      editor: {
        show: false,
        uuid: '',
      },
      sender: {
        show: false,
        uuid: '',
        info: '',
        ai_uuid: '',
      },
      receiver: {
        show: false,
        uuid: '',
        info: '',
        ai_uuid: '',
      },
      senderlist: {
        show: false,
        uuid: '',
      },
      receiverlist: {
        show: false,
        uuid: '',
      },
      resList: {
        show: false,
        identityUuid: '',
      },
      dataTable: [],
      monDataTable: [],
      cInfo: '',
      //快速编辑备份
      copyData: null,
    };
  },
  mounted() {},
  methods: {
    edit(index, row) {
      this.editor.uuid = row.uuid;
      this.editor.show = true;
    },
    sendConf(index, row) {
      this.senderlist.uuid = row.uuid;
      this.senderlist.show = true;
    },
    receConf(index, row) {
      this.receiverlist.uuid = row.uuid;
      this.receiverlist.show = true;
    },
    addSender() {
      this.sender.info = null;
      this.sender.ai_uuid = null;
      this.sender.uuid = this.senderlist.uuid;
      this.sender.show = true;
    },
    addRece() {
      this.receiver.info = null;
      this.receiver.ai_uuid = null;
      this.receiver.uuid = this.receiverlist.uuid;
      this.receiver.show = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delRece() {
      this.$refs.receiverList.doSeleDel();
    },
    delSend() {
      this.$refs.senderList.doSeleDel();
    },
    // 启动身份下全部发送资源
    startAllSend() {
      this.$refs.senderList.startAllSend();
    },
    // 停止身份下全部发送资源
    stopAllSend() {
      this.$refs.senderList.stopAllSend();
    },
    // 启动身份下全部接收资源
    startAllRece() {
      this.$refs.receiverList.startAllRece();
    },
    // 停止身份下全部发送资源
    stopAllRece() {
      this.$refs.receiverList.stopAllRece();
    },
    async deletes() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择数据！');
        return;
      }
      await this.confirm();
      let array = this.multipleSelection.map((v) => v.uuid);
      await idApi.deletes(array);
      await this.pageTable.handleLoad();
      let resp = monitorApi.select();
      this.$store.dispatch('client/loadMonTableData', resp.datarows);
    },
    // 保存发送配置
    async saveSendConf() {
    const res = await this.$refs.idsendconf.saveSendConf().
      this.$refs.senderList.reload();
    },
    // 回调重新刷新接收配置列表
    condRece() {
      this.receiver.show = false;
      this.$refs.receiverList.dataTableLoad();
    },
    // 回调重新刷新发送配置列表
    condSend() {
      this.sender.show = false;
      this.$refs.senderList.dataTableLoad();
    },
    // 保存接收配置
    async saveReceConf() {
      await this.$refs.idrececonf.saveReceConf().then(() => {
        this.$refs.receiverList.reload();
      });
    },
    editRece(val) {
      this.receiver.ai_uuid = this.receiverlist.uuid;
      this.receiver.info = val.row;
      this.receiver.show = true;
    },
    editSend(val) {
      this.sender.ai_uuid = this.senderlist.uuid;
      this.sender.info = val.row;
      this.sender.show = true;
    },
    saveId() {
      this.pageTable.handleLoad();
      this.editor.show = false;
    },
    doSave() {
      this.$refs.idconf.save();
    },
    //-----------------------表格快速编辑开始---------------------------------
    // 快速添加数据
    fastAddData() {
      this.pageTable.data.push(Object.assign({}, defaultFormData));
    },
    // 快速编辑
    fastEditData(scope) {
      this.copyData = Object.assign({}, scope.row);
      scope.row.$isEditing = true;
    },
    //确认提交
    async fastConfirm(scope) {
      if (!scope.row.clientname || !scope.row.clientdxpid) {
        this.$message.error('请补全数据!');
        return;
      }
      await this.confirm();
      try {
        if (scope.row.uuid) {
          scope.row.cliEntName = scope.row.clientname;
          scope.row.cliEntDxpid = scope.row.clientdxpid;
          scope.row.cliEntIcno = scope.row.clienticno;
          await idApi.edit(scope.row);
        } else {
          scope.row.cliEntName = scope.row.clientname;
          scope.row.cliEntDxpid = scope.row.clientdxpid;
          scope.row.cliEntIcno = scope.row.clienticno;
          await idApi.save(scope.row);
        }
        scope.row.$isEditing = false;
        this.copyData = null;
        this.pageTable.handleLoad();
      } catch (e) {
        this.$message.error(e.respCode);
      }
    },
    //取消提交
    async fastCancel(scope) {
      await this.confirm();
      if (this.copyData) {
        Object.assign(scope.row, this.copyData);
        scope.row.$isEditing = false;
        this.copyData = null;
      } else {
        this.pageTable.data.splice(scope.$index, 1);
      }
    },
    //删除记录
    async fastDelete(scope) {
      if (scope.row.uuid) {
        await this.confirm();
        await idApi.deletes([scope.row.uuid]);
        this.pageTable.handleLoad();
      } else {
        this.dataTable.splice(scope.$index, 1);
      }
    },
    // 当前身份下资源全部开启监听
    async fastStartAll(index, row) {
      await idApi.identityResAllStart(row.uuid).then(() => {
        this.queryMondataTable(row.uuid);
      });
    },
    // 当前身份下资源全部停止监听
    async fastStopAll(index, row) {
      await idApi.identityResAllStop(row.uuid).then(() => {
        this.queryMondataTable(row.uuid);
      });
    },
    //-----------------------表格快速编辑结束---------------------------------
    startAllRes() {
      idApi.startAllRes();
    },
    // 展示资源状态列表
    showResList(uuid) {
      this.resList.identityUuid = uuid;
      this.resList.show = true;
    },
    // 鼠标悬停 显示table之前 查询该身份下的资源
    queryMondataTable(uuid) {
      idApi.queryMondataTable(uuid).then((resp) => {
        this.monDataTable = resp.datarows;
      });
    },
  },
};
</script>
